import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Card, Row, Col, ProgressBar } from 'react-bootstrap';
import { MdManageAccounts,MdHolidayVillage } from "react-icons/md";
import { FaUsers,FaTasks,FaRoute, FaSortAmountDownAlt } from "react-icons/fa";
import { TbReportAnalytics } from "react-icons/tb";
import { useNavigate } from 'react-router-dom';
import { IoDocumentTextOutline } from 'react-icons/io5';
import ChartComponentEmployee from '../../components/ChartComponentEmployee';
import moment from 'moment';
import ToastFile from '../../utils/ToastFile';
import { getAllTaskLogbyEmployee } from '../../api/TaskApi';

const EmployeeDashboard = () => {

  const [isLoading, setIsloading] = useState(false);
    const [taskLogs, setTaskLogs] = useState([]);
    const user = JSON.parse(localStorage.getItem("user"));
    const [currentMonth, setCurrentMonth] = useState(moment());
  
    const navigate = useNavigate();
    const handleCardClick = (path) => {
      navigate(path);
    };
  
    useEffect(() => {
      const monthStartDate = currentMonth.clone().startOf("month").toDate();
      const monthEndDate = currentMonth.clone().endOf("month").toDate();
      getTaskLog(monthStartDate, monthEndDate);
    }, [currentMonth]);
  
    const getTaskLog = (monthStartDate, monthEndDate) => {
      setIsloading(true);
      let startDate = moment(new Date(monthStartDate)).format("YYYY-MM-DD");
      let endDate = moment(new Date(monthEndDate)).format("YYYY-MM-DD");

       getAllTaskLogbyEmployee(user.id, startDate, endDate)
            .then((res) => {
              if (res.status === 200) {
                setTaskLogs(res?.data?.data?.taskLogs.reverse());
              } else {
                ToastFile("Failed to fetch tasks", "error");
              }
            })
            .catch((err) => {
              console.error("Error fetching tasks:", err);
              ToastFile("Error fetching tasks", "error");
            })
            .finally(() => {
              setIsloading(false);
            });
    };
  
 
  return (
    <Layout>
      <div className="mb-4"
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
      Dashboard
          </div>

      <Row className="mb-4">
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/employee/profile')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Manage Account</Card.Title>
              <div className="d-flex justify-content-center align-items-center">
                <MdManageAccounts size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
         <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/mytask')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-success">My Task</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <FaTasks size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/taskhistory')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Task History</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <IoDocumentTextOutline size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/invoice')}> 
            <Card.Body className='p-4'>
              <Card.Title className="text-success">Invoice</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <TbReportAnalytics size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
         <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/parcelsorting')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Parcel Sorting</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <FaSortAmountDownAlt size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/holidays')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-success">Holidays</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <MdHolidayVillage size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <div
        style={{
          backgroundColor: "#e4e1e1",
          padding: "20px",
          width: "100%",
          justifyContent: "center",
          marginBottom:"20px"
        }}
      >
        <ChartComponentEmployee
          data={taskLogs}
          currentMonth={currentMonth}
          setCurrentMonth={setCurrentMonth}
          isLoading={isLoading}
          setIsloading={setIsloading}
        />
      </div>
    </Layout>
  );
};

export default EmployeeDashboard;